import React, { useState, useEffect, useRef } from "react";
import "./ActualitesManagement.scss";
import Actualite from "../Actualite/Actualite";
import ActualiteManagerCard from "./ActualiteCard/ActualiteCard";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  formatDateFrenchLocale,
  findItemInEditManagementVisibility,
  filterByTransmitter,
  findManagementContentByLabel,
} from "Services/functions";
import { updateNews } from "Redux/Actions/newsActions";
import { updateMenu } from "Redux/Actions/menuActions";
import { updatePagination } from "Redux/Actions/paginationActions";
import { FaFileUpload } from "react-icons/fa";
import RessourceCard from "Components/Ressources/RessourceCard/RessourceCard";
import Management from "Components/Management/Management";
import Loader from "Components/Loader/loader";
import { Link } from "react-router-dom";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import { ME, newsMgmtButtons } from "Components/Management/ManagementButtons";
/**
 * Permet d'afficher la page de gestion des actus
 * Accessible pour les administrateurs, alumni et personnels
 */
const ActualitesManagement = (props) => {
  // *****************************************************************
  // ****************** UseStates / UseRef *********************
  // *****************************************************************
  const actualitesContainerRef = useRef(null);
  const newsMngRef = useRef(null);
  const [url, setUrl] = useState(null);
  const [states, setStates] = useState([]);
  const [lastNews, setLastNews] = useState(null);
  const [btnList, setBtnList] = useState(
    newsMgmtButtons.map((x) => {
      return { ...x };
    })
  );
  //? On ne fait pas de requête si aucun état n'est sélectionné
  //? Des états par défaut sont appliqués dans un useEffect
  //! Permet d'éviter de faire deux requêtes au chargement de la page
  useFetchGetPagination(url, props.auth.token, props.handleUpdateNews);

  useEffect(() => {
    props.handleUpdateNews({ currentTransmitter: [ME] });
    return () => {
      props.handleUpdateNews({ dataFromPagination: null });
    };
  }, []);

  useEffect(() => {
    //? remise à zéro si les états sont chargés
    //? et que l'url ne contient pas de state
    if (states && states?.length > 0 && !url?.href?.includes("state")) {
      if (newsMngRef.current !== null) {
        window.scroll({
          top: newsMngRef.current.offsetTop,
          behavior: "smooth",
        });
      }
      let newUrl = new URL(`${process.env.REACT_APP_BASE_URL_API}/news`);
      newUrl.searchParams.set(
        "university[]",
        props.auth.universityConnected.id
      );
      newUrl.searchParams.set("order[modifiedAt]", "desc");
      newUrl.searchParams.set("itemsPerPage", 20);
      states.forEach((state) => {
        newUrl.searchParams.append("state[]", state?.id);
      });
      newUrl.searchParams.append("createdBy[]", props.auth.userConnected.id);

      setUrl(newUrl);
    }
  }, [states]);

  useEffect(() => {
    /// Récupérer les statuts, et les filtrer par ordre alphabétique
    if (props.news.etats && props.news.etats.length > 0) {
      setStates([]);
      let tempArray = props.news.etats.map((state) => {
        return { ...state };
      });
      tempArray = tempArray.sort((a, b) => a.name.localeCompare(b.name));
      tempArray.forEach((state) => {
        if (state.name.lastIndexOf("é") === state.name.length - 1) {
          state.name = state.name + "e";
        }
      });
      setStates(tempArray);
    }
  }, [props.news.etats]);

  useEffect(() => {
    // Charge la dernière offre en fonction de l'emetteur choisi
    props.news.dataFromPagination?.data &&
      url?.href?.includes("page=1") &&
      setLastNews(props.news.dataFromPagination?.data[0]);
  }, [props.news.dataFromPagination?.data]);

  return (
    <>
      <div className="gestion_evenements" ref={newsMngRef}>
        <div className="gestion_evenements__title">
          <h1 className="h1_trait_dessus">
            {props.auth.isAdmin
              ? `Gérer les actus/${
                  findManagementContentByLabel(
                    "conseilsTitle",
                    props.admin.editManagement,
                    null,
                    props.auth.universityConnected.id
                  ).content
                }`
              : "Gérer mes actus"}
          </h1>
          <Management
            states={states}
            btnEntreprise={btnList[2]}
            actualPage={"actu"}
            currentTransmitter={
              btnList.filter((btn) => btn.isActive === true)[0].transmitter
            }
            updateFunction={props.handleUpdateNews}
            setUrl={setUrl}
          ></Management>
        </div>
        <div className="gestion_evenements__body">
          <div className="gestion_evenements__body__left">
            {props.auth.isAdmin &&
              btnList.map((btnStatus, index) => {
                return (
                  <button
                    className={
                      btnStatus.isActive
                        ? "btn-bleu " + "item" + index
                        : "btn-blanc " + "item" + index
                    }
                    onClick={() => {
                      setUrl(
                        filterByTransmitter(
                          "news",
                          url,
                          btnList[index].transmitter,
                          props.auth.userConnected.id
                        )
                      );
                      props.handleUpdateNews({
                        currentTransmitter: btnList[index].transmitter,
                        dataFromPagination: null,
                      });
                      var i = 0;
                      setBtnList(
                        btnList.map((btn) => {
                          btn.isActive = i == index;
                          i++;
                          return btn;
                        })
                      );
                    }}
                    key={index}
                  >
                    {btnList[index].text}
                  </button>
                );
              })}
            <h3>Dernière actu créée</h3>
            {lastNews !== null && lastNews !== undefined && (
              <Actualite
                categorie={
                  lastNews.category?.label !== null
                    ? lastNews.category.label
                    : "Autres"
                }
                title={lastNews.title}
                chapeau={lastNews.description}
                publicationDate={lastNews.publishedAt}
                newsDetails={lastNews}
                url={lastNews?.imageUrl || lastNews?.nexusImageUrl || "img1"}
                nexusUrl={lastNews?.nexusImageUrl}
              />
            )}
          </div>
          <div
            className="gestion_evenements__body__right"
            ref={actualitesContainerRef}
          >
            {props.news.dataFromPagination?.loaded ? (
              props.news.dataFromPagination?.data?.length > 0 ? (
                props.news.dataFromPagination.data[0]?.state &&
                props.news.dataFromPagination.data
                  .filter(
                    (actu) =>
                      actu.state.statusLabel !== "Brouillon" ||
                      actu.createdBy?.id == props.auth.userConnected.id
                  )
                  .sort(
                    (a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt)
                  )
                  .map((news, index) => (
                    <ActualiteManagerCard
                      titre={news.title ? news.title : "Titre non renseigné"}
                      date={formatDateFrenchLocale(news.publishedAt)}
                      statut={news.state}
                      image={news?.imageUrl || news?.nexusImageUrl || "img1"}
                      nexusUrl={news.nexusImageUrl}
                      key={index}
                      id={news.id}
                      feedback={news.feedback?.feedback}
                      transmitterName={props.news.currentTransmitter[0]}
                    />
                  ))
              ) : (
                <span>Aucune actualité ne correspond à votre recherche</span>
              )
            ) : (
              <Loader></Loader>
            )}
          </div>
        </div>
        <TempPagination
          result={props.news.dataFromPagination}
          refItemParent={actualitesContainerRef}
          rows={20}
        />
      </div>
      {props.auth.userConnected.userRoles.some(
        (i) =>
          i.roleName == "ROLE_ADMIN_DU_PORTAIL" &&
          findItemInEditManagementVisibility(
            "visibleConseils",
            props.admin.editManagementBoolean
          )
      ) && (
        <div className="gestion_ressources">
          <div className="gestion_ressources__title">
            <h1 className="h1_trait_dessus">{`Gérer les ${
              findManagementContentByLabel(
                "conseilsTitle",
                props.admin.editManagement,
                null,
                props.auth.universityConnected.id
              ).content
            }`}</h1>
            <div className="gestion_ressources__title__filtres">
              <Link to={{ pathname: `/actualites` }}>
                <BtnBlancLeft
                  btnTexte="Déposer un document"
                  btnAction={() => {
                    props.handleMenu({
                      activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                        (v) => v.label == "Créer une actu/conseil"
                      ),
                    });
                  }}
                >
                  <FaFileUpload />
                </BtnBlancLeft>
              </Link>
            </div>
          </div>
          <div className="gestion_ressources__container">
            {props.ressources?.ressourcesData?.length > 0 &&
              props.ressources.ressourcesData
                .reverse()
                .map((ressource) => (
                  <RessourceCard
                    key={ressource.id}
                    name={ressource.name}
                    dataRessource={ressource}
                    size={ressource.size}
                    iconeConseil={ressource.id % 3}
                    gestion
                  />
                ))}
          </div>
        </div>
      )}
    </>
  );
};

ActualitesManagement.propTypes = {
  auth: PropTypes.object,
  activeIndex: PropTypes.number,
  news: PropTypes.object,
  handleUpdateNews: PropTypes.func,
  handleMenu: PropTypes.func,
  items: PropTypes.object,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  ressources: PropTypes.object,
  admin: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  news: state.news,
  items: state.items,
  pagination: state.pagination,
  ressources: state.ressources,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateNews: (value) => {
    dispatch(updateNews(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActualitesManagement);
